import { put, call } from 'redux-saga/effects'
import AuthActions, { AuthTypes } from '../Redux/AuthRedux'
import localforage from 'localforage'
import validate from '../Config/Validator'
import AuthValidator from '../Validations/AuthValidations'
import { baseListen, baseFetchToken } from './BaseSaga'

// attempts to login
export function * login (api) {
  yield baseListen(AuthTypes.AUTH_REQUEST,
    fetchLoginAPI,
    api)
}

export function * checkLogin (api, getToken) {
  yield baseListen(AuthTypes.AUTH_CHECK_REQUEST,
    fetchCheckLoginAPI,
    api,
    getToken)
}

export function * fetchLoginAPI (api, { data }) {
  const hasError = validate(data, AuthValidator.loginConstraints, { format: 'custom' })
  if (hasError) {
    yield put(AuthActions.authFailure(hasError))
  } else {
    const res = yield call(api.login, data)
    if (!res.ok) {
      yield put(AuthActions.authFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
    }
    if (!res.data.error) {
      if (res.data.data.role === 'user') {
        yield put(AuthActions.authLogout())
        yield put(AuthActions.authFailure('Access Denied!'))
      } else {
        yield localforage.setItem('access_token', res.data.data.token)
        yield window.localStorage.setItem('user_role', res.data.data.role)
        if (!res.data.data.branch_code) {
          yield window.localStorage.setItem('branch', 'ID')
        } else {
          yield window.localStorage.setItem('branch', res.data.data.branch_code)
        }
        yield put(AuthActions.authSuccess(res.data.data))
      }
    } else {
      yield put(AuthActions.authFailure(res.data.message))
    }
  }
}

export function * fetchCheckLoginAPI (api, getToken, { data }) {
  yield baseFetchToken(api.checkLogin,
    data,
    getToken,
    AuthActions.authSuccess,
    AuthActions.authFailure)
}

export function * logout () {
  yield localforage.removeItem('access_token')
  yield window.localStorage.removeItem('user_role')
  yield window.localStorage.removeItem('branch')
  const pathname = window.location.pathname
  if (pathname !== '/login') {
    window.location.href = '/login'
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/AuthSagas.js